import { create } from "zustand";
import { BundleElement } from "./elementBundlesStore";
import { ICoreApartmentRoom } from "../interfaces/ICoreApartmentBundles";
import { BundleDetachErrorEnum } from "../enums/BundleDetachErrorEnum";
import { DetachRoomElementsBody } from "../services/coreApi/BundleDetachResult";

export type DetachLevel = 'apartment' | 'room';

/** What the Detach elements command opens the dialog with. */
export interface DetachDialogRequest {
    bundleName: string;
    elements: BundleElement[];      // The picked elements
    rooms: ICoreApartmentRoom[];    // The apartment's rooms, for a room-level bundle
    defaultLevel: DetachLevel;      // The original bundle's
    defaultRoomId: number | null;
    onConfirm: (body: DetachRoomElementsBody) => void;
    onCancel: () => void;
}

/** The Detach elements dialog. The command owns the request; the dialog only shows its progress. */
interface DetachDialogState {
    request: DetachDialogRequest | null;    // Null when closed
    busy: boolean;
    error: BundleDetachErrorEnum | null;

    open: (request: DetachDialogRequest) => void;
    setBusy: (busy: boolean) => void;
    setError: (error: BundleDetachErrorEnum | null) => void;
    close: () => void;
}

export const useDetachDialogStore = create<DetachDialogState>()((set) => ({
    request: null,
    busy: false,
    error: null,

    open: (request) => set({ request, busy: false, error: null }),
    setBusy: (busy) => set(busy ? { busy, error: null } : { busy }),
    setError: (error) => set({ error }),
    close: () => set({ request: null, busy: false, error: null }),
}));
